import { CustomDialog } from 'components/Dialogs/CustomDialog';
import { RequestForm } from '../RequestForm';
import { ICandidate } from 'common/request/interfaces/candidate';
import { AnimatedLoaderModal } from '../../../../components/Loaders/AnimatedLoader';

import styles from './styles.module.scss';

type InputProps = {
  isLoading: boolean;
  open: boolean;
  setOpen: (open: boolean) => void;
  onSubmit: (candidate: ICandidate) => void;
  params?: {
    candidateFirstName?: string;
    candidateLastName?: string;
    candidatePhone?: string;
    candidateEmail?: string;
    candidateEmployeeId?: string;
    disableCandidateFields?: boolean;
  };
};

export const CreateRequestDialog = ({
  isLoading = false,
  open = false,
  setOpen,
  onSubmit,
  params,
}: InputProps) => {
  return (
    <CustomDialog open={open} setOpen={setOpen} title="New Request">
      {isLoading ? (
        <AnimatedLoaderModal
          isLoading={isLoading}
          classNameWrapper={styles.loaderWrapper}
        />
      ) : (
        <RequestForm
          onSubmit={onSubmit}
          defaultValues={params}
          disableCandidateFields={params?.disableCandidateFields}
        />
      )}
    </CustomDialog>
  );
};
